<div class="d-lg-block d-none">
  <fgb-page-header
    [pageTitle]="'challenges.page.title'"
    [backButtonLink]="'/'"
    [kidsBanner]="'banners/kids-challenges.jpg'"
  ></fgb-page-header>
</div>
<div class="d-lg-none">
  <ng-container *inPopulation="[population.Kids]">
    <fgb-page-header
      [pageTitle]="'challenges.page.title'"
      [backButtonLink]="'/'"
      [kidsBanner]="'banners/kids-challenges.jpg'"
    ></fgb-page-header>
  </ng-container>
  <ng-container *notInPopulation="[population.Kids]">
    <fgb-page-header [pageTitle]="'challenges.page.title'" [backButtonLink]="'/'" [showBanner]="false"></fgb-page-header>
  </ng-container>
</div>

<div class="container pt-lg-4">
  <fgbcl-badge-achieved></fgbcl-badge-achieved>
</div>

<div class="pt-lg-4 position-relative z-1">
  <fgbcl-scorecard-list-view [icon]="'chevron_right'" [showPlaceholder]="true"></fgbcl-scorecard-list-view>
</div>
